import script from "./QDemoSwitchRole.vue?vue&type=script&setup=true&lang=js"
export * from "./QDemoSwitchRole.vue?vue&type=script&setup=true&lang=js"

import "./QDemoSwitchRole.vue?vue&type=style&index=0&id=67cb9fd7&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67cb9fd7"]])

export default __exports__